module.exports = __webpack_public_path__ + "static/media/ico_btn_compositeur.6ea7a878.svg";